export default __webpack_public_path__ + "static/media/lily.5200750c.png";